import { useCallback, useState } from 'react';
import type { SorterResult } from 'antd/es/table/interface';
import type { CalendarRow } from '../../../../types/calendar';

export function useCalendarSort() {
    const [sortBy, setSortBy] = useState<string>('promo_start_date');
    const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');

    const handleTableChange = useCallback(
        (_pagination: any, _filters: any, sorter: SorterResult<CalendarRow> | SorterResult<CalendarRow>[]) => {
            const singleSorter = Array.isArray(sorter) ? sorter[0] : sorter;
            if (!singleSorter.order) {
                setSortBy('promo_start_date');
                setSortOrder('asc');
                return;
            }
            setSortBy(singleSorter.field as string);
            setSortOrder(singleSorter.order === 'ascend' ? 'asc' : 'desc');
        },
        [],
    );

    const getColumnSortOrder = useCallback(
        (dataIndex: string) => {
            if (sortBy !== dataIndex) return null;
            return sortOrder === 'asc' ? ('ascend' as const) : ('descend' as const);
        },
        [sortBy, sortOrder],
    );

    return { sortBy, sortOrder, handleTableChange, getColumnSortOrder };
}
